import { ref, nextTick } from 'vue';

export function useKeyboardNavigate({ options, visible, scrollToOption, selected, multiple }) {
    const hoverIndex = ref(-1);
    const hoverOption = ref(null);
    const keyboardNavigate = ref(false);

    const navigateOptions = (direction: 'next' | 'prev') => {
        if (!visible.value || !options.value.length) return;

        let newIndex = hoverIndex.value;

        if (newIndex === -1) {
            newIndex = direction === 'next' ? -1 : 0;
        }

        let tries = 0;

        do {
            newIndex = direction === 'next'
                ? (newIndex + 1) % options.value.length
                : (newIndex - 1 + options.value.length) % options.value.length;

            const option = options.value[newIndex];
            tries++;
            if (option && !option.disabled && !option.groupDisabled && option.visible) {
                hoverIndex.value = newIndex;
                hoverOption.value = option;
                keyboardNavigate.value = true;
                break;
            }
        } while (tries < options.value.length);

        nextTick(() => scrollToOption?.(hoverOption.value));
    };

    const resetHoverState = () => {
        if (multiple?.value) {
            hoverIndex.value = -1;
            hoverOption.value = null;
        } else {
            const index = options.value.indexOf(selected?.value);
            hoverIndex.value = index;
            hoverOption.value = options.value[index] ?? null;
        }
    };

    return {
        hoverIndex,
        hoverOption,
        resetHoverState,
        keyboardNavigate,
        navigateOptions,
    };
}
